<template>
	<div class="contents">
		<h3 class="mark">
			<div class="type">
				<span>
					<img src="../assets/result-detail-communcation-icon01.svg" alt="*" />あなたのコミュニケーション
				</span>
			</div><!-- end .type -->
			<div class="cover">
				積極型{{communicateResult.percentageLeft}}%、独立型{{communicateResult.percentageRight}}%
			</div><!-- end .cover -->
		</h3><!-- end .mark -->
		<div class="sentence">
			<div class="catch">
				<span class="left">
					Detailed
				</span>
				<span class="right">
					explanation
				</span>
			</div><!-- end .catch -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>自分の外向性にマッチしたコミュケーション環境に身を置き、これからまだまだ自身の価値を高めることができる</h2>
			<img src="../assets/result-detail-communication-outleft01.svg" alt="*" class="visual" />
			<div class="caption">
				外向性をフルに生かしたコミュニケーション能力をストックしていこう
			</div><!-- end .caption -->
			<p>3番目はコミュニケーションの特性を分析しました。自分のコミュニケーションの能力や癖は、内向的(もしくは外向的)気質を掛け合わさり、恋愛からビジネスまで、幅広い社会活動の結果に影響を与えるからです。</p>

			<p>単純に言えば、内向的な人が好かれるコミュニケーションと、外向的な人が好かれるコミュニケーションはまったく違います。あなたが内向的な人にも関わらず、外向的な人のコミュニケーションをお手本にしていると、自分の個性を伸ばせずに、苦しむことになるでしょう。

			<p>あなたのコミュニケーション積極型{{communicateResult.percentageLeft}}%という結果は、あなたの外向性を生かした結果と言えるでしょう。積極型のパーセンテージが高い人ほど、自身の外向性を対人関係の中で存分に発揮することができると言えるでしょう。

			<p>ですから、あなたのやるべきことは、現状のベクトルを突き進むことです。外向度とコミュニケーションスキルをもっと高めていけば、あなたの価値はどんどん高まっていきます。</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>多彩なギブ＆テイクを重ねていくことで、あなたは極上のコミュニケーターへ成り上がっていく</h2>
			<img src="../assets/result-detail-communication-outleft02.svg" alt="*" class="visual" />
			<div class="caption">
				自分が相手に価値を与えるだけでなく、積極的に任せたり、頼んだりしていく
			</div><!-- end .caption -->
			<p>外向的な性格と積極型のコミュニケーションはとても相性が良いです。つまり、双方を高めると、あなたはコミュニケーターとしてあらゆる場で活躍できるようになります。</p>
			<p>最も有能はコミュニケーターは、多様なギブ＆テイクを重ねています。多様なギブ＆テイクとは、より多くの人に、多くのカタチで、価値を与えたり、手助けをしたり、逆に任せたり、頼んだりしていくという体験です。</p>
			<p>ギブの種類はいくらでもあるでしょう。イベントの幹事をしたり、自分の詳しい分野について初心者をエスコートしたり、時には嫌われ役を買ったり、ご飯をご馳走して励ましてあげたりといったことです。対象は、友人、異性、先輩、後輩、社長など多岐に渡れば渡るほど良いでしょう。</p>
			<p>また、このタイプには、ギブだけを行っている人も少なくありません。実はテイク(してもらう)というコミュニケーション体験を重ねることも非常に重要です。お願いしたり、託したり、丸投げしたり、多様なテイクの機会を増やすことは、あなたのコミュニケーション能力をさらに豊かにしていくのです。</p>
			<p>
				がむしゃらにただ人に会って雑談をしていても、あなたの才能は大きく引き上げることは難しいでしょう。
			</p>
			<!-- ////////////////////////////////////////////////////////////////////////// -->
			<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
			<!-- ////////////////////////////////////////////////////////////////////////// -->	
			<h2>勢いとノリ、外向的な人ならではの瞬発力に磨きを掛け、奇遇な運や縁が呼び寄せよう</h2>
			<img src="../assets/result-detail-communication-outleft03.svg" alt="*" class="visual" />
			<div class="caption">
				一瞬や一期一会大切にできる外向的人間は、偶然の産物に数多く出会える
			</div><!-- end .caption -->
			<p>
				あなたは、自分の創作物や成果物で人を惹き付けるというよりは、あなた自身の人間性が惹き付けるほうが性に合っています。ですから、自分のコミュ力や外向性の高さに自負があったとしても、まだまだ高めていこうとする姿勢が非常に大切になっていきます。</p>
			<p>
				コミュニケーションを1つにとっても、アプローチ、ヒアリング、カウンセリング、コーチング、ディレクション、プレゼンテーション、コンサルティング、クロージング、アサーションなど、様々な能力やスキルがあります。こうしたスキルを積んでいくと、あなたの外向性がより大きく生かされていきます。外向的な人は、外向的な場面で自己肯定感を得られるとすごく快感を得られますから、あなたは自分らしいことをしながら、成功体験を得られていくのです。
			</p>
			<p>1つの出会いで、相手を大事にしていくことで、奇遇な運や縁が増えていきます。あなたは、自分自身のペースや行動に意識を置く傾向にあるので、相手に興味を持つという意識を常に強く持っておくと良いでしょう。</p>
			<p>ただし、本質的には相手のことは分からないと割り切る気持ちも、このタイプには非常に大切です。相手にギブをもたらそうとしたり、相手をケアしようとしたり、その姿勢や気持ちが大事なのであって、実質的に相手の本音を理解することにこだわると、あなたらしさが半減します。</p>
			<p>「結局のところ、本人の気持ちは本人しか分からないわけで、自分なりのギブや興味を相手に注ごう！」そういったマインドでコミュニケーションを持つと、あなたはより様々なパーソナリティの人と上手に関わっていけるでしょう。</p>
		</div><!-- end .sentence -->
	</div><!-- end .guidance -->			
</template>

<script>


export default {
	name: 'ResultDetailCommunicationOutLeft',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},		
		// communicate
		communicateResult:function(){
			return this.$store.getters.communicateResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
